import '@/assets/styles/index'

import '@/plugins/axios'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import type { Router } from 'vue-router'
import App from './App.vue'
import { tippy } from './plugins/tippy'

const main = async () => {
  let router: Router = null!
  if (import.meta.env.RUNTIME_TARGET === 'front') {
    if (import.meta.env.MODE === 'development' || !window.location.hostname.endsWith('chinauos.com')) {
      document.title = '驱动平台 - 驱动投递'
    }
    router = (await import('@/sites/front-desk/router/index')).router
  }
  if (import.meta.env.RUNTIME_TARGET === 'back') {
    router = (await import('@/sites/back-desk/router/index')).router
  }

  const app = createApp(App)
  window.$app = app
  window.$router = router

  const pinia = createPinia()
  app.use(pinia).use(tippy).use(router)

  router.isReady().then(() => {
    console.info('router isReady')
    app.mount('#app')
  })
}
main()
